export function extractGradientColors(gradient: string) {
  const cleanedString = gradient.trim().toLowerCase();
  const colorRegex = /(#[0-9a-f]{3,8}|rgba?\([^)]+\)|var\([^)]+\))/g;
  const colors = cleanedString.match(colorRegex);
  return colors && colors.length >= 2 ? { color1: colors[0], color2: colors[1] } : null;
}
